module.exports = __webpack_public_path__ + "img/site-bg-mp4.b08a3b89.png";